import { useEffect, useState } from 'react';
import { tsvParse } from 'd3-dsv';
import 'unfetch/polyfill';

function parseTsvData(tsv) {
  var data = tsvParse(tsv, function(row){
    return {
      ags: row.AGS,
      parlament: row.Bundesland,
      gruppe: row.Fraktion_Bund,
      label: row.Fraktion,
      male: parseInt(row.m,10),
      female: parseInt(row.w,10),
      total: parseInt(row.gesamt,10)
    }
  }).reduce(function(p,c){
    if (!p.hasOwnProperty(c.ags)) p[c.ags] = {
      hero: (c.parlament === "Bundestag"),
      parlament: c.parlament,
      fraktionen: [],
      gesamt: {}
    };

    if (c.gruppe === "gesamt") {
      p[c.ags].gesamt = {
        male: c.male,
        female: c.female,
        total: c.total
      };
    } else {
      p[c.ags].fraktionen.push({
        gruppe: c.gruppe,
        label: c.label,
        male: c.male,
        female: c.female,
        total: c.total
      });
    }
    return p;
  },{});
  return Object.keys(data).reduce(function(p,k){
    if (data[k].hero) p.hero = data[k];
    else p.list.push(data[k]);
    return p;
  },{ hero: null, list: [], ready: true });
}

const useData = () => {
  const [data, setData] = useState({});

  useEffect(() => {
    (async () => {
      const response = await fetch('data/data.tsv');
      const tsv = await response.text();
      const data = parseTsvData(tsv);
      setData(data);
    })();
  }, []);

  return data;
};

export default useData;
